<template>
  <div>
    <!-- Table dialog servicios -->
    <el-dialog
      :title="title"
      :visible="isVisible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :fullscreen="false"
      top="5vh"
      width="800px"
      center
    >
      <el-form :model="data">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="Código postal">
              <el-input
                v-model="data.code"
                size="small"
                autocomplete="off"
                clearable
                type="number"
                maxlength="5"
                @clear="loadSectors()"
                @blur="loadSectors()"
                :disabled="data.loading"
                :loading="data.loading"
                style="width:100%"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="Sector">
              <el-select
                v-model="data.sector"
                placeholder="Sin sector"
                size="small"
                clearable
                :disabled="data.loading"
                :loading="data.loading"
                style="width:100%"
              >
                <el-option
                  v-for="sector in sectors"
                  :key="sector.uuid"
                  :value="sector.sector"
                >
                  <span style="font-size: small;">
                    {{ sector.state }} / {{ sector.city }} / {{ sector.sector }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="Deshabilitar">
              <el-select
                v-model="data.disabled"
                placeholder="Sin proveedor"
                size="small"
                clearable
                filterable
              >
                <el-option :label="'Shipper'" :value="'shipper'">
                  <span style="font-size: small;">
                    <i class="el-icon-postcard"></i>
                    Shipper
                  </span>
                </el-option>
                <el-option :label="'Recipient'" :value="'recipient'">
                  <span style="font-size: small;">
                    <i class="el-icon-postcard"></i>
                    Recipient
                  </span>
                </el-option>
                <el-option :label="'Ningúno'" :value="null">
                  <span style="font-size: small;">
                    <i class="el-icon-postcard"></i>
                    Ningúno
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="4">
            <el-form-item label="Cobertura">
              <el-switch
                v-model="data.covered"
                size="small"
                active-text="Si"
                inactive-text="No"
                inactive-color="#ff4949"
                active-color="#13ce66"
              >
              </el-switch>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item label="Ocurre">
              <el-switch
                v-model="data.ocurre"
                size="small"
                active-text="Si"
                inactive-text="No"
                inactive-color="#ff4949"
                active-color="#13ce66"
              >
              </el-switch>
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="Dias de espera">
              <el-input
                v-model="data.days"
                size="small"
                autocomplete="off"
                clearable
                type="number"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Carriers">
              <el-select
                v-model="carriersSelected"
                placeholder="Sin proveedor"
                size="small"
                clearable
                multiple
                filterable
                :disabled="data.loading"
                :loading="data.loading"
                @change="loadServices()"
                style="width:100%"
              >
                <el-option
                  v-for="carrier in carriers"
                  :key="carrier.uuid"
                  :label="carrier.name"
                  :value="carrier.name"
                >
                  <span style="font-size: small;">
                    <i class="el-icon-postcard"></i>
                    {{ carrier.name }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Services">
              <el-select
                v-model="servicesSelected"
                placeholder="Sin proveedor"
                size="small"
                clearable
                multiple
                filterable
                :disabled="data.loading"
                :loading="data.loading"
                style="width:100%;"
              >
                <el-option
                  v-for="service in services"
                  :key="service.uuid"
                  :label="
                    formatServiceLabel(
                      `${service.carrier} / ${service.service}`
                    )
                  "
                  :value="service.uuid"
                >
                  <span style="font-size: small;">
                    <i class="el-icon-postcard"></i>
                    {{ service.carrier }} / {{ service.service }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="success"
          icon="el-icon-check"
          @click="handleSave"
          round
          :loading="data.loading"
        >
          Guardar
        </el-button>
      </span>
    </el-dialog>
    <!-- END Table dialog servicios -->
  </div>
</template>

<script>
import { CSApi } from "@/libraries/api";

export default {
  name: "DialogLoadPostalCode",
  components: {},
  props: ["isVisible"],
  data() {
    return {
      title: "Nuevo Código postal",
      data: {},
      carriers: [],
      services: [],
      carriersSelected: [],
      servicesSelected: [],
      sectors: [],
    };
  },
  watch: {
    async isVisible() {
      // Create
      this.data = {
        sector: "",
        code: "",
        covered: true,
        outOfArea: false,
        outOfPickup: false,
        ocurre: false,
        days: 0,
        service: "",
        disabled: null,
      };

      const response = await CSApi().get(`/coverage/service?all=true`);

      const { data } = response.data;
      this.carriers = data.filter((service) => service.countryCode == "MX");
    },
  },

  methods: {
    async handleSave() {
      let options = {
        message: "Se guardaron los cambios con exito.",
        type: "success",
        duration: 4000,
      };

      try {
        if (
          !this.data.code ||
          !this.carriersSelected.length ||
          this.data?.days < 0
        )
          throw "Insert correct data";

        this.data.loading = true;

        const body = [];

        if (this.servicesSelected.length) {
          this.servicesSelected.forEach((service) => {
            body.push({
              sector: this.data.sector || "",
              code: this.data.code,
              covered: this.data?.covered ?? true,
              outOfArea: false,
              outOfPickup: false,
              ocurre: this.data?.ocurre || false,
              days: parseInt(this.data?.days) || 0,
              service: service,
              disabled: this.data?.disabled,
            });
          });
        } else {
          this.services.forEach((service) => {
            body.push({
              sector: this.data.sector || "",
              code: this.data.code,
              covered: this.data?.covered ?? true,
              outOfArea: false,
              outOfPickup: false,
              ocurre: this.data?.ocurre || false,
              days: parseInt(this.data?.days) || 0,
              service: service.uuid,
              disabled: this.data?.disabled,
            });
          });
        }

        const response = await CSApi().put(`/coverage/postalCode`, body);

        // If error
        if (!response?.data?.success)
          throw response?.data?.data?.error?.message || "Error";

        // If success
        this.update();
        this.handleClose();
      } catch (error) {
        options.showClose = true;
        options.message = error;
        options.type = "error";
      } finally {
        this.data.loading = false;

        this.$message(options);
      }
    },

    handleClose() {
      this.$emit("close");
    },

    update() {
      this.carriersSelected = [];
      this.servicesSelected = [];
      this.$emit("update");
    },

    formatServiceLabel(service) {
      if (service.length > 27) return `${service.substring(0, 27)}...`;
      return service;
    },

    async loadServices() {
      this.data.loading = true;
      const promises = this.carriersSelected.map(async (carrier) => {
        try {
          const response = await CSApi().get(
            `/coverage/service?page=1&pageSize=500&carrier=${carrier}&country=MX`
          );

          return response.data.data.filter(
            (service) => service.countryCode == "MX"
          );
        } catch (error) {
          return [];
        }
      });

      const responses = await Promise.all(promises);

      this.services = responses.flat();
      this.data.loading = false;
    },

    async loadSectors() {
      try {
        // Reset sectors
        this.data.loading = true;
        this.sectors = [];

        // Get sectors by postal code from CS API
        const response = await CSApi().get(
          `/coverage/postalCode/${this.data.code}?page=1&pageSize=30&all=true`
        );
        if (response) this.sectors = response.data.data;
      } catch (error) {
        options.duration = 0;
        options.showClose = true;
        options.message = error;
        options.type = "error";
        this.$message(options);
      } finally {
        this.data.loading = false;
      }
    },
  },
};
</script>

<style>
.el-select-dropdown__item {
  padding: 10px 20px;
  height: 55px;
  width: 330px;
}
.el-form-item__label {
  font-size: 14px;
  font-weight: 100;
  line-height: 14px;
}
.el-switch__label * {
  line-height: 1;
  font-size: 14px;
  font-weight: 100;
}
.el-input .el-input--small .el-input--suffix {
  width: 260px;
}
</style>
